export const APPLICATION_BASE_URL = 'APPLICATION_BASE_URL';
export const EXPORT_JOB_MAX_REQUESTS = 'EXPORT_JOB_MAX_REQUESTS';
export const MAINTENANCE_MODE = 'MAINTENANCE_MODE';
export const VOUCHER_CODE_GENERATION_FEATURE_ENABLED = 'VOUCHER_CODE_GENERATION_FEATURE_ENABLED';
